<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
<div class="card crd p-3">
    <div class="row">
        <div class="col-md-10 col10 mt-2">
            <h2 >पेमेंट गेटवे</h2>
        </div>
        <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
            alt=""> </button> </a> </div>
        <div class="col-md-12" (mouseover)="showpayment(true,'1')"
            (mouseout)="showpayment(false,'1')" id="1">
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe class="i-frame" src="https://www.youtube.com/embed/tScYv5RleU8"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div>
        <div class="col-md-12 mt-3">
         
            <label for="" class="spm" >पेमेंट गेटवे एक ऐसी तकनीक है जो सुविधा
                प्रदान करती है
                एक वेबसाइट के बीच भुगतान जानकारी का सुरक्षित और कुशल हस्तांतरण,
                मोबाइल एप्लिकेशन, या पॉइंट-ऑफ़-सेल सिस्टम और एक बैंक या वित्तीय
                संस्थान। यह व्यापारी (विक्रेता) और के बीच एक सेतु का काम करता है
                भुगतान प्रोसेसर या अधिग्रहणकर्ता बैंक, यह सुनिश्चित करते हुए कि ग्राहक का
                भुगतान हो
                विवरण एन्क्रिप्ट किए गए हैं और सुरक्षित रूप से प्रसारित किए गए हैं। </label>

        </div>
        <div class="col-md-12 mt-3">
            
            <label for="" class="spm" >पेमेंट गेटवे का मुख्य उद्देश्य अधिकृत
                करना है
                और भुगतान लेनदेन को इस तरह से संसाधित करें जो सुरक्षित और निर्बाध दोनों हो।
            </label>
        </div>
        <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'2')"
            (mouseout)="showpayment(false,'2')" id="2">
         
           <h3 >
                यहां बताया गया है कि भुगतान गेटवे आम तौर पर कैसे काम करता है:
            </h3>

            <label class="mt-4 spn" ><b>ग्राहक लेन-देन शुरू करता है:</b>&nbsp;
                जब कोई ग्राहक किसी ई-कॉमर्स वेबसाइट या मोबाइल ऐप पर खरीदारी करता है, तो वे
                चेकआउट प्रक्रिया के दौरान अपनी भुगतान जानकारी (क्रेडिट कार्ड विवरण, बैंक
                खाता जानकारी, आदि) दर्ज करते हैं।
            </label>
            <label class="mt-4 spn" ><b>डेटा एन्क्रिप्शन:</b>&nbsp;भुगतान गेटवे
                ट्रांसमिशन के दौरान इसकी सुरक्षा सुनिश्चित करने के लिए ग्राहक के भुगतान डेटा
                को एन्क्रिप्ट करता है। यह एन्क्रिप्शन संवेदनशील जानकारी को अनधिकृत पहुंच या
                चोरी से बचाने में मदद करता है। </label>

            <label class="mt-4 spn" ><b>अधिग्रहणकर्ता बैंक को ट्रांसमिशन:
                </b>&nbsp; एन्क्रिप्टेड भुगतान डेटा अधिग्रहणकर्ता बैंक या भुगतान प्रोसेसर को
                प्रेषित किया जाता है। अधिग्रहणकर्ता बैंक लेनदेन को मान्य करने और यह जांचने
                के लिए जिम्मेदार है कि ग्राहक के पास खरीदारी पूरी करने के लिए पर्याप्त
                धनराशि या क्रेडिट उपलब्ध है या नहीं। </label>
            <label class="mt-4 spn" ><b> प्राधिकरण:</b>&nbsp; अधिग्रहण करने
                वाला बैंक ग्राहक के जारीकर्ता बैंक (वह बैंक जिसने क्रेडिट कार्ड जारी किया था
                या भुगतान के लिए उपयोग किया जा रहा खाता) को एक प्राधिकरण अनुरोध भेजता है।
                जारीकर्ता बैंक धोखाधड़ी या किसी अन्य समस्या के लिए लेनदेन और चेक की पुष्टि
                करता है। यदि स्वीकृत हो जाता है, तो यह अधिग्रहणकर्ता बैंक को एक प्राधिकरण
                कोड वापस भेजता है। </label>
            <label class="mt-4 spn" ><b> लेनदेन अनुमोदन या अस्वीकृति:</b>&nbsp;
                जारीकर्ता बैंक की प्रतिक्रिया के आधार पर, अधिग्रहणकर्ता बैंक या भुगतान
                प्रोसेसर भुगतान गेटवे को सूचित करता है कि लेनदेन स्वीकृत है या अस्वीकृत।
            </label>
            <label class="mt-4 spn" ><b>ग्राहक अधिसूचना: </b>&nbsp; ग्राहक को
                लेनदेन की स्थिति पर तत्काल प्रतिक्रिया प्राप्त होती है। यदि अनुमोदित हो, तो
                वे अपनी खरीद की पुष्टि देखेंगे। यदि अस्वीकार कर दिया जाता है, तो उन्हें कोई
                अन्य भुगतान विधि आज़माने के लिए कहा जा सकता है।
            </label>
            <label class="mt-4 spn" ><b>निपटान:</b>&nbsp; एक बार लेन-देन
                स्वीकृत हो जाने के बाद, धनराशि ग्राहक के खाते से व्यापारी के खाते में
                स्थानांतरित कर दी जाती है, आमतौर पर बैंकिंग प्रणाली के माध्यम से।

            </label>
            <label class="mt-4 spn" >भुगतान गेटवे ऑनलाइन व्यवसायों के लिए
                आवश्यक हैं क्योंकि वे भुगतान स्वीकार करने का एक सुरक्षित और कुशल तरीका
                प्रदान करते हैं। वे संवेदनशील ग्राहक डेटा की सुरक्षा करने, धोखाधड़ी के जोखिम
                को कम करने और भुगतान प्रक्रिया को सुव्यवस्थित करने में मदद करते हैं।
            </label>
        </div>
        <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
            (mouseout)="showpayment(false,'3')" id="3">
           
            <h3 >पेमेंट गेटवे का उपयोग कहां किया जा सकता है? </h3>
            <label for="" class="spn mt-3" >पेमेंट गेटवे एक ऐसी तकनीक है जिसका
                उपयोग विभिन्न संदर्भों में इलेक्ट्रॉनिक लेनदेन, विशेष रूप से ऑनलाइन भुगतान
                को सुविधाजनक बनाने के लिए किया जाता है। यहां कुछ सामान्य परिदृश्य और स्थान
                दिए गए हैं जहां भुगतान गेटवे का उपयोग किया जाता है:
            </label>
            <div class="mt-3 p-1 " style="margin-left: 10%;">
                <ul class="p-1 ">
                    <li >ई-कॉमर्स वेबसाइटें</li>
                    <li >ऑनलाइन मार्केटप्लेस</li>
                    <li >मोबाइल क्षुधा</li>
                    <li >प्वाइंट ऑफ सेल (पीओएस) सिस्टम</li>
                    <li >सदस्यता सेवाएँ</li>
                    <li >दान प्लेटफार्म</li>
                    <li >ऑनलाइन बुकिंग प्लेटफॉर्म</li>
                    <li >सरकारी वेबसाइटें</li>
                    <li >शैक्षणिक संस्था</li>
                    <li >पीयर-टू-पीयर लेनदेन</li>
                    <li >दूरसंचार</li>
                    <li >गेमिंग और मनोरंजन</li>
                    <li >डिजिटल डाउनलोड</li>
                    <li >सीमा पार लेनदेन</li>
                    <li >धर्मार्थ संगठन</li>
                </ul>
            </div>
        </div>
        <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'4')"
            (mouseout)="showpayment(false,'4')" id="4">
          
            <h3 >
                पेमेंट गेटवे हमारे समाज की बेहतरी में कैसे योगदान देता है?
            </h3>
            <label for="" class="spn mt-3" >भुगतान गेटवे सुरक्षित, सुविधाजनक और
                कुशल इलेक्ट्रॉनिक लेनदेन की सुविधा प्रदान करके समाज को कई लाभ प्रदान करता
                है। यहां कुछ तरीके दिए गए हैं जिनसे भुगतान गेटवे समाज की बेहतरी में योगदान
                करते हैं: </label>
            <label class="mt-4 spn" ><b>वित्तीय समावेशन: </b>&nbsp; भुगतान
                गेटवे व्यक्तियों को, विशेष रूप से दूरदराज या कम सेवा वाले क्षेत्रों में,
                डिजिटल अर्थव्यवस्था में भाग लेने की क्षमता प्रदान करके वित्तीय समावेशन में
                अंतर को पाटने में मदद करते हैं। </label>
            <label class="mt-4 spn" ><b> सुविधा और दक्षता:</b>&nbsp; भुगतान
                गेटवे भुगतान प्रक्रिया को सुव्यवस्थित करते हैं, जिससे लेनदेन त्वरित और
                सुविधाजनक हो जाता है। यह दक्षता एक तेज़ गति वाले समाज में विशेष रूप से
                मूल्यवान है जहाँ समय सबसे महत्वपूर्ण है। </label>
            <label class="mt-4 spn" ><b> वैश्विक वाणिज्य:</b>&nbsp; भुगतान
                गेटवे वैश्विक वाणिज्य को बढ़ावा देते हुए सीमा पार लेनदेन की सुविधा प्रदान
                करते हैं। व्यवसाय दुनिया भर के ग्राहकों तक पहुंच सकते हैं, और उपभोक्ता
                विभिन्न क्षेत्रों के उत्पादों और सेवाओं तक पहुंच सकते हैं।
            </label>
            <label class="mt-4 spn" ><b> आर्थिक विकास: </b>&nbsp; ऑनलाइन
                वाणिज्य को सक्षम करके, भुगतान गेटवे आर्थिक विकास में योगदान करते हैं।
                व्यवसाय, विशेष रूप से छोटे और मध्यम उद्यम (एसएमई), अपने ग्राहक आधार का
                विस्तार कर सकते हैं और बिक्री बढ़ा सकते हैं, जिससे आर्थिक विकास हो सकता है।
            </label>
            <label class="mt-4 spn" ><b> कैश हैंडलिंग में कमी:</b>&nbsp; पेमेंट
                गेटवे के उपयोग से नकद लेनदेन पर निर्भरता कम हो जाती है, जिससे संबंधित
                जोखिमों में कमी आती है। </label>
            <label class="mt-4 spn" ><b> पारदर्शिता और जवाबदेही: </b>&nbsp;
                भुगतान गेटवे के माध्यम से इलेक्ट्रॉनिक लेनदेन एक डिजिटल निशान छोड़ते हैं,
                जिससे पारदर्शिता और जवाबदेही बढ़ती है। यह सरकार, वित्त और धर्मार्थ संगठनों
                सहित विभिन्न क्षेत्रों में फायदेमंद हो सकता है। </label>

            <label class="mt-4 spn" ><b> धर्मार्थ योगदान: </b>&nbsp;दान और
                गैर-लाभकारी संगठन कुशलतापूर्वक ऑनलाइन दान एकत्र करने के लिए भुगतान गेटवे का
                लाभ उठाते हैं। इससे लोगों के लिए सामाजिक कार्यों, आपदा राहत प्रयासों और
                सामुदायिक विकास परियोजनाओं में योगदान करना आसान हो जाता है। </label>
            <label class="mt-4 spn" ><b> शैक्षणिक पहुंच:</b>&nbsp; शैक्षणिक
                संस्थान ट्यूशन, फीस और अन्य शैक्षणिक खर्चों के लिए ऑनलाइन भुगतान की सुविधा
                के लिए भुगतान गेटवे का उपयोग करते हैं। यह शिक्षा तक पहुंच को बढ़ाता है और
                छात्रों और अभिभावकों के लिए वित्तीय लेनदेन को सरल बनाता है। </label>
            <label class="mt-4 spn" ><b> स्वास्थ्य सेवाएँ:</b>&nbsp; स्वास्थ्य
                सेवा क्षेत्र में भुगतान गेटवे चिकित्सा सेवाओं, बीमा भुगतान और ऑनलाइन
                फ़ार्मेसी खरीदारी से संबंधित लेनदेन को आसान बनाने में योगदान करते हैं।
            </label>
            <label for="" class="mt-4 spn" > <b>उपभोक्ता सशक्तिकरण:</b>&nbsp;
                भुगतान गेटवे उपभोक्ताओं को सुरक्षित और सुविधाजनक भुगतान विकल्प प्रदान करके
                सशक्त बनाते हैं। यह, बदले में, समग्र उपभोक्ता अनुभव को बढ़ाता है। </label>
        </div>
    </div>

</div>
</div>
<div class="col-md-4 hide-tbl content2 ">
<div class="card crd p-4">
    <div class="row">
        <div class="col-md-12">
           
            <h5 >
                विषयसूची:
            </h5>
        </div>
        <div class="col-md-12 mt-2">
            <a href="#1">
                <div class="row">
                    <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">
                   
                        <span class="videoHover" style="cursor: pointer;"
                            [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                            >
                            पेमेंट गेटवे क्या है?

                        </span>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-3">
            <a href="#2">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">
                        
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                            > पेमेंट गेटवे कैसे काम करता है? </span>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-3">
            <a href="#3">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">
                     
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                            >
                            इसका उपयोग कहां किया जा सकता है? </span>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-3">
            <a href="#4">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">
                        
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                            >पेमेंट गेटवे के लाभ| </span>
                    </div>
                </div>
            </a>
        </div>
    </div>
</div>
</div>
<div class="col-md-9 hide ft-9 ">
    <hr>
    <div class=" row crd">
        <div class="col-md-12">
           
            <a [routerLink]="['/payment-gateway-working']"> <button class="btn  btn-color" style="margin-left: 58% ;" (click)="menues('PayG')"
                >पेमेंट गेटवे उद्योग की कार्यप्रणाली &nbsp;<img src="./assets/Arrow 2 1.svg"
                    alt=""></button></a>
        </div>
    </div>
</div>
</div>